<template>
  <v-dialog v-model="dialog" max-width="900">
    <v-card>
      <v-card-title>Agregar producto</v-card-title>
      <v-card-text>

        <!-- Elegir producto -->
        <v-row>
          <v-col cols="12" md="6" class="mt-4 mb-0">
            <v-autocomplete
              v-model="selectedProduct"
              outlined
              :class="{'primary--text': selectedProduct, 'green--text': selectedProduct}"
              clearable
              placeholder="Buscar producto"
              :items="items"
              item-text="name"
              item-value="uuid"
              hide-selected
              hide-no-data
              return-object
              @input.native="search"
              @change="productSelected"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row v-if="selectedProduct && !isVariantSelected" class="text-rigth ml-1">
          <v-col>
            <v-row>
              <v-col>
                <p class="body-1 font-weight-medium primary--text" v-if="!hasVariants">NO HAY VARIANTES DISPONIBLES</p>
                <p class="body-1 font-weight-medium primary--text" v-else>SELECCIONA UNA OPCIÓN</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="hasVariants">Variantes encontradas: {{ table.data.length }}</v-col>
        </v-row>

        <!-- Tabla con variantes -->
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          item-key="_id"
          v-model="table.selected"
          class="custom-table"
        >
          <template v-slot:item="{ item }">
            <tr @click="selectTableRow(item)">
              <td>{{ item.provider }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.brand }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.contenido }}</td>
              <td>$ {{ item.amount }}</td>
              <td>$ {{ calculatePriceProductWithTaxes(item) | toFixNumber(2) | numberWithComma }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <!-- Modal para seleccional la cantidad -->
      <v-dialog v-model="isOpen" persistent max-width="500px">
        <v-card v-if="table.selected.length > 0">
          <v-card-title>
            <span class="mb-1">{{ selectedProduct.name }}</span>
          </v-card-title>
          <v-divider :thickness="5"></v-divider>
          <v-card-text>
            <div class="mt-2">
              <p>Provedor: {{ table.selected[0].provider || '---' }}</p>
              <p>Descripción: {{ table.selected[0].description || '---' }} </p>
              <p>Cantidad de contenido: {{ table.selected[0].contentQuantity || '---' }} {{ table.selected[0].contentUnit || '---' }} </p>
              <p class="primary--text font-weight-bold">Selecciona la cantidad: </p>
            </div>

          <v-row class="d-flex justify-center">
            <v-col cols="4">
              <div style="text-align: center;" class="caption">Cantidad de producto</div>
              <v-divider></v-divider>
              <div style="text-align: center;">
                <v-text-field
                    class="my-0 py-0 primary--text font-weight-bold"
                    v-model="quantity"
                    clearable
                    variant="solo"
                    type="number"
                  ></v-text-field>
                <v-divider></v-divider>
                <span class="caption ml-auto">{{ table.selected[0].unit || '---' }}</span>
              </div>
            </v-col>
            <v-col cols="4">
              <div style="text-align: center;" class="caption">Precio aproximado</div>
              <v-divider></v-divider>
              <div style="text-align: center;">
                <p style="font-size: 12px; text-align: center;" class="mt-2">
                  {{ calculateApproximatePrice() | toFixNumber(2) | numberWithComma | prefix('$') }}
                </p>
                <v-divider></v-divider>
                <span class="caption ml-auto">con impuestos</span>
              </div>
            </v-col>
          </v-row>

          </v-card-text>
          <v-divider :thickness="5"></v-divider>
          <v-card-actions class="d-flex justify-end">
            <div class="mt-2">
              <v-btn rounded small depressed outlined @click="isOpen=false" class="mr-2">Cancelar</v-btn>
              <v-btn color="primary" rounded small depressed :disabled="quantity <= 0" @click="onAccept">Agregar producto</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-actions>
        <v-spacer/>
        <v-btn rounded small depressed outlined @click="closeModal">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { debounce } from 'lodash'

export default {
  data () {
    return {
      dialog: false,
      isOpen: false,
      selectedProduct: null,
      selectedChoice: null,
      isVariantSelected: false,
      items: [],
      quantity: 1,
      hasVariants: true,
      table: {
        headers: [
          { text: 'Proveedor', value: 'provider' },
          { text: 'Descripción', value: 'description' },
          { text: 'Marca', value: 'brand' },
          { text: 'Presentación', value: 'unit' },
          { text: 'Contenido', value: 'contenido' },
          { text: 'Precio Unitario', value: 'amount' },
          { text: 'Precio con impuestos', value: 'total' }
        ],
        selected: [],
        data: []
      },
      originalTableData: []
    }
  },
  watch: {
    dialog (newVal) {
      if (newVal) {
        this.quantity = 1
      }
    }
  },
  methods: {
    calculatePriceProductWithTaxes (product) {
      let priceWithTaxes = product.amount
      const hasBaseAmount = (product.taxes || []).every(tax => tax.baseAmount && tax.baseAmount >= 0)

      if (hasBaseAmount) {
        const taxesAmount = product.taxes.reduce((acc, tax) => {
          const base = tax.isQuota ? tax.base : (tax.base / 100)
          return acc + (tax.baseAmount * base)
        }, 0)
        return priceWithTaxes + taxesAmount
      } else {
        let totalTaxes = 0
        const taxes = product.taxes || []
        const ieps = taxes.find(tax => tax.satCode === '003' && tax.base > 0)
        const iva = product.taxes.find(tax => tax.satCode === '002' && tax.base > 0)

        const otherTaxes = taxes
          .filter(tax => !['003', '002'].includes(tax.satCode))

        if (ieps) {
          const iepsAmount = (ieps.isQuota ? ieps.base : ieps.base / 100) * (product.amount - (product.discount || 0))
          priceWithTaxes = priceWithTaxes + iepsAmount
        }

        totalTaxes = otherTaxes.reduce((acc, num) => {
          let taxApplied
          if (num.isQuota) {
            taxApplied = num.base
          } else {
            taxApplied = (num.base / 100) * product.amount
          }
          acc += taxApplied
          return acc
        }, 0)

        if (iva) {
          priceWithTaxes = priceWithTaxes + (priceWithTaxes * (iva.base / 100))
        }

        priceWithTaxes = totalTaxes + priceWithTaxes

        return priceWithTaxes
      }
    },
    openModal () {
      this.dialog = true
    },
    closeModal () {
      this.resetModal()
      this.dialog = false
    },
    onAccept () {
      this.$emit('product-added', {
        uuid: this.selectedProduct.uuid,
        quantity: parseFloat(this.quantity),
        choice: this.table.selected[0].uuid
      })
      this.isOpen = false
      this.resetModal()
      this.closeModal()
    },
    resetModal () {
      this.selectedProduct = null
      this.isVariantSelected = false
      this.items = []
      this.table.selected = []
      this.table.data = []
      this.originalTableData = []
    },
    search: debounce(async function (event) {
      const params = { name: `/${event.target.value}/i`, skip: 0, global: true, limit: 20 }
      const products = await this.$api.get('/v1/products', params)
      this.items = products.data
    }, 600),
    async productSelected (event) {
      if (event) {
        const response = await this.$api.get(`/v1/products/${event.uuid}`)

        this.originalTableData = []

        if (!response || !response.choices || response.choices.length === 0) {
          this.hasVariants = false
          return
        }

        this.hasVariants = true

        for (const choice of response.choices) {
          const product = this.selectedProduct
          const provider = choice.provider ? choice.provider.name : ' '
          const description = choice.description || ' --- '
          const brand = choice.brand ? choice.brand.toUpperCase() : ' --- '
          const unit = choice.display ? choice.display.name : ' '
          const contentQuantity = choice.contentQuantity || ' '
          const contentUnit = choice.contentUnit ? choice.contentUnit.name : ' '
          const amount = choice.amount ? choice.amount : ' '
          const taxes = choice.taxes && choice.taxes
          const uuid = choice.uuid && choice.uuid

          this.originalTableData.push({
            provider,
            description,
            brand,
            unit,
            contentQuantity,
            contentUnit,
            contenido: `${contentQuantity} ${contentUnit}`,
            amount,
            taxes,
            uuid,
            product
          })
        }
        this.fillTableWithOriginalData()
      }
    },
    selectTableRow (item) {
      this.table.selected = [item]
      this.isOpen = true
      this.isVariantSelected = true
    },
    onBack () {
      this.fillTableWithOriginalData()
      this.isVariantSelected = false
    },
    fillTableWithOriginalData () {
      this.table.data = this.originalTableData.slice()
    },
    calculateApproximatePrice () {
      return this.quantity * (this.calculatePriceProductWithTaxes(this.table.selected[0]) || 0)
    }
  }
}
</script>

<style scoped>
.custom-table.v-data-table tbody tr:hover {
  background-color: #58e8b880 !important;
  cursor: pointer
}
</style>
